module.exports = __webpack_public_path__ + "static/media/DSCF1271-1.c18cba42.jpg";